import { Validation } from './validation.interface';

export interface ICustomerDetailsErrors {
  firstName: Validation;
  lastName: Validation;
  telephoneNumber?: Validation;
  address1: Validation;
  address2: Validation;
  town: Validation;
  county: Validation;
  country: Validation;
  postCode: Validation;
}
